import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useEffectOnceWhen, useTimeoutWhen, useSessionstorageState } from "rooks"

import { useKeydownOnce } from './utils/useKeydownOnce';
import { useDebouncedFunction } from './utils/useDebouncedFunction';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import CropIcon from '@mui/icons-material/Crop';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useIdleTimer } from 'react-idle-timer'
import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Menu from '@mui/material/Menu'
import Box from '@mui/material/Box'
import Icon from '@mui/material/Icon'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import CircularProgress from '@mui/material/CircularProgress'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import SettingsIcon from '@mui/icons-material/Settings'
import ExcelsiorSettingsDrawer from './ExcelsiorSettingsDrawer'
import { CustSlider, FabMenuButton, FabMenuButtonSmall } from './ExcelsiorElementsLibrary'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import Divider from '@mui/material/Divider'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'
import useWindowManager from './useWindowManager'
import { isMobile } from './utils/deviceUtils';

//import { setHome } from './store/stageSlice';

import { useSelector, useDispatch } from 'react-redux';
import {
  setZoomed,
  setZoomedPosition,
  setMode,
  setDoNext,
  setWorking,
  setSettingsMenuOpen,
  setBuildBounding,
  setBuildGenerate,
  setEnd
} from './store/readerSlice';
import "./Excelsior.css";

// const timeoutLength = 300

export function ExcelsiorChrome() {


  //REDUX
  const dispatch = useDispatch()
  //  const admin = useSelector(state => state.reader.admin)
  const zoomed = useSelector(state => state.reader.zoomed)
  const mode = useSelector(state => state.reader.mode)
  const currentPage = useSelector(state => state.reader.currentPage);
  const currentPages = useSelector(state => state.reader.currentPages);
  const numPages = useSelector(state => state.reader.numPages)
  const issueObject = useSelector(state => state.reader.issueObject)
  const issueName = useSelector(state => state.reader.currentIssueName)
  const working = useSelector(state => state.reader.working)
  const animating = useSelector(state => state.reader.animating)
  const settingsMenuOpen = useSelector(state => state.reader.settingsMenuOpen)
  const fabMenuSwitchValue = useSelector(state => state.reader.fabMenuSwitchValue)
  const buildBounding = useSelector(state => state.reader.buildBounding)
  const buildGenerate = useSelector(state => state.reader.buildGenerate)
  const lockMode = useSelector(state => state.reader.lockMode)

  const setZoomedStore = (v) => dispatch(setZoomed(v))
  const setZoomedPositionStore = (v) => dispatch(setZoomedPosition(v))
  const setModeStore = (v) => dispatch(setMode(v))
  const setCurrentActionStore = (v) => dispatch(setDoNext(v))
  const setWorkingStore = (v) => dispatch(setWorking(v))
  const setSettingsMenuOpenStore = (v) => dispatch(setSettingsMenuOpen(v))
  const setBuildBoundingStore = (v) => dispatch(setBuildBounding(v))
  const setBuildGenerateStore = (v) => dispatch(setBuildGenerate(v))
  const setEndStore = (v) => dispatch(setEnd(v))

  const {
    size,
    portrait
  } = useWindowManager()



  const [goOpenMenu, setGoOpenMenu] = useState(false)
  const [mouseOverMenu, setMouseOverMenu] = useState(false)
  const [fullscreen, setFullScreen] = useState(false);
  const [isCursorHidden, setIsCursorHidden] = useState(false);
  const topLeftAnchor = useRef(null)
  const debounceTimeout = useRef(null); // Using useRef to hold mutable debounceTimeout value


  // var mouseOverMeFlag = false

  const totalDistance = useRef(0)
  const oldCursorX = useRef(null)
  const oldCursorY = useRef(null)

  // Create refs for variables used in onTouchMove and onTouchStart
  const zoomedRef = useRef(zoomed);
  const modeRef = useRef(mode);
  const workingRef = useRef(working);
  const animatingRef = useRef(animating);
  const settingsMenuOpenRef = useRef(settingsMenuOpen);
  const goOpenMenuRef = useRef(goOpenMenu);


  const [showMenuAtFirst, setShowMenuAtFirst] = useSessionstorageState("excelsior:showmenuatstart", true)
  useTimeoutWhen(() => showMeFirstEnd(), 4500, showMenuAtFirst)

  const [fabHide, setFabHide] = useState(!fabMenuSwitchValue)

  const onIdle = () => {

    // if((mode === 'focus')){
    //   document.body.style.cursor = 'none'; // Hide the cursor
    //   setIsCursorHidden(true);
    // }

    // Do some idle action like log out your user
    if (!goOpenMenu && !settingsMenuOpen && !isMobile()) {
      setFabHide(fabHide => true)
    }
  };

  const openMenu = () => {
    //console.log(mouseOverMenu)

    setGoOpenMenu(goOpenMenu => true)
  }
  const closeMenu = () => {
    //console.log(mouseOverMenu)
    if (!mouseOverMenu) {

      setGoOpenMenu(goOpenMenu => false)

    }
  }

  const handleExit = useCallback(() => {
    // dispatch(setHome())
    window.open("https://linktr.ee/inkvaultio", "_blank", "noopener,noreferrer");
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const mouseMonitor = useCallback((e) => {
    if (e.clientY < window.innerHeight * .2 && (!portrait ? e.clientX <= window.innerWidth * .2 : true) && mode !== 'build') {
      openMenu()
    } else {
      closeMenu()

      var cursorThreshold = Math.min(size.width, size.height) * .1
      cursorThreshold = cursorThreshold < 20 ? 20 : cursorThreshold > 500 ? 500 : cursorThreshold

     

      if (oldCursorX.current) totalDistance.current += Math.sqrt(Math.pow(oldCursorY.current - e.clientY, 2) + Math.pow(oldCursorX.current - e.clientX, 2))
  
      if (totalDistance.current >= cursorThreshold) {
        //run code here
        if (!mouseOverMenu) {
          setFabHide(fabHide => false)
        }
        totalDistance.current = 0
      }

      oldCursorX.current = e.clientX
      oldCursorY.current = e.clientY
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window, openMenu, closeMenu, size, totalDistance, oldCursorX, oldCursorY])


  const onActive = (event) => {

    // Do some active action
    if (goOpenMenu && !settingsMenuOpen && !isMobile()) {
      setFabHide(fabHide => false)

    }

  }


  const {
    activate
  } = useIdleTimer({
    onIdle,
    onActive,
    timeout: 1000,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'mouseup',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
  })



  useEffectOnceWhen(() => {
    if (!fabMenuSwitchValue && !showMenuAtFirst) {
      setFabHide(false)
    }
  })

  useEffect(() => {
    zoomedRef.current = zoomed;
    modeRef.current = mode;
    workingRef.current = working;
    animatingRef.current = animating;
    settingsMenuOpenRef.current = settingsMenuOpen;
    goOpenMenuRef.current = goOpenMenu;
  }, [zoomed, mode, working, animating, settingsMenuOpen, goOpenMenu]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let initialX = null;
    let initialY = null;
    let lastTap = null;
    let timeout = null;
    let isDoubleTap = false;

    const minDistance = 50; // Minimum distance in pixels to consider it a swipe
    const debounceDelay = 100; // Debounce delay in milliseconds
    let isSwipeLocked = false;

    const onTouchStart = (e) => {
      // if ((modeRef.current === 'classic' || modeRef.current === 'build') && zoomedRef.current) { return }
      if (workingRef.current || animatingRef.current) { return }
      if (settingsMenuOpenRef.current || goOpenMenuRef.current) { return }
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    };

    const onTouchMove = (e) => {

      if (e.touches.length > 1 && modeRef.current === 'focus') {
        // Handle pinch zoom gesture
        // const dx = e.touches[0].clientX - e.touches[1].clientX;
        // const dy = e.touches[0].clientY - e.touches[1].clientY;
        // const distance = Math.sqrt(dx * dx + dy * dy);
        // Use 'distance' to calculate the zoom level and update your image scale
      } else {

        if ((modeRef.current === 'classic' || modeRef.current === 'build') && zoomedRef.current) { return }
        if (workingRef.current || animatingRef.current || isSwipeLocked) { return }
        if (settingsMenuOpenRef.current || goOpenMenuRef.current) { return }
        if (!initialX || !initialY) {
          return;
        }

        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;

        const diffX = initialX - currentX;
        const diffY = initialY - currentY;

        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (Math.abs(diffX) > minDistance) {
            // Clear existing debounce timeout if present
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }

            // Debounce swipe action
            debounceTimeout.current = setTimeout(() => {
              if (diffX > 0) {
                // Swiped left
                modeRef.current === 'classic' || modeRef.current === 'build' ? goNextPage() : goNextPanel();
                onTouchEnd(true)
              } else {
                // Swiped right
                modeRef.current === 'classic' || modeRef.current === 'build' ? goPrevPage() : goPrevPanel();
                onTouchEnd(true)

              }
              isSwipeLocked = true;
              setTimeout(() => {
                isSwipeLocked = false;
              }, debounceDelay);
            }, debounceDelay);

            // Swipe detected, return early
            return;
          }
        }
        // Now check for double tap
        if (isDoubleTap) {
          isDoubleTap = false;
          return;
        }
      }
    };

    const onTouchEnd = (e) => {
      if (workingRef.current || animatingRef.current) { return }

      const currentX = e.changedTouches[0].clientX;
      const currentY = e.changedTouches[0].clientY;

      const diffX = initialX - currentX;
      const diffY = initialY - currentY;

      const distance = Math.sqrt(diffX * diffX + diffY * diffY);

      if (distance > minDistance) {
        isDoubleTap = false;
      } else {

        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;
        clearTimeout(timeout);
        if (tapLength < 500 && tapLength > 0 && e !== true) {
          // Double tap action
          // You can call any function here that you want to trigger on double tap
          //console.log('Double Tap');
          isDoubleTap = true;
          if (modeRef.current === 'focus') {
            setModeStore('classic');
          } else {
            const touch = e.changedTouches[0];
            const targetRect = touch.target.getBoundingClientRect();
            const offsetX = touch.clientX - targetRect.left;
            const offsetY = touch.clientY - targetRect.top;
            setZoomedPositionStore({ x: offsetX, y: offsetY });
            zoomClick(!zoomedRef.current);
          }

        } else {
          timeout = setTimeout(() => {
            // console.log('Single Tap');
          }, 500);
        }
        lastTap = currentTime;

      };
      initialX = null;
      initialY = null;
    };

    // Add event listener
    document.addEventListener('touchstart', onTouchStart, false);
    document.addEventListener('touchmove', onTouchMove, false);
    document.addEventListener('touchend', onTouchEnd, false);

    // Clean up
    return () => {
      // Clear any remaining timeouts
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);// eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(() => {
    const handleFullScreenChange = () => {
      if (document.fullscreenElement) {
        setFullScreen(true);
      } else {
        setFullScreen(false);
      }
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  useEffect(() => {
    const handleMouseMove = () => {
      if (isCursorHidden) {
        document.body.style.cursor = 'auto'; // Show the cursor
        setIsCursorHidden(false);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isCursorHidden]);


  useEffect(() => {

    const func = (e) => { mouseMonitor(e) }
    window.addEventListener('mousemove', func)

    return () => {
      window.removeEventListener('mousemove', func)
    }
  }, [mouseOverMenu, mouseMonitor])




  const showMeFirstEnd = () => {
    setShowMenuAtFirst(false)
    activate()
    setFabHide(fabHide => false)
  }


  const mouseOverMe = (e) => {
    setMouseOverMenu(mouseOverMenu => true)
  }
  const mouseOffMe = (e) => {
    setMouseOverMenu(mouseOverMenu => false)
  }

  const forceCloseMenu = (e) => {
    setMouseOverMenu(mouseOverMenu => false)
    setGoOpenMenu(goOpenMenu => false)

    if (e.detail === 1) {
      //single click
      onIdle()
    }
  }


  /*

    DRAWER

  */



  const SettingsDrawer = () => {
    return (
      <>
        <ExcelsiorSettingsDrawer anchor={"right"} />
      </>
    )
  }

  /*

          KEY BINDINGS

  */



  const leftKey = useLatestCallback(useDebouncedFunction(() => {
    //console.log("left key")
    mode === 'classic' || mode === 'build' ? goPrevPage() : goPrevPanel()
  }, 300)); // 300 milliseconds delay

  const rightKey = useLatestCallback(useDebouncedFunction(() => {
    //console.log("right key")
    mode === 'classic' || mode === 'build' ? goNextPage() : goNextPanel()
  }, 300)); // 300 milliseconds delay

  useKeydownOnce('ArrowLeft', leftKey, 500);
  useKeydownOnce('ArrowRight', rightKey, 500);

  /*

*/

  const handleSliderChange = (event, newValue) => {
    if (working) { return }
    setWorkingStore(true)
    setCurrentActionStore(["goToPage", newValue])
  }

  const BackToLibraryBar = () => {
    return (
      <>
        <Box sx={{ display: "inline-block", mb: 1, width: 'inherit' }}>
          <Stack direction="row">
            <AppBar position="static">
              <Toolbar variant="dense">

                <IconButton edge="start" color="#yellow" aria-label="exit" size="small" onClick={handleExit}>
                  <Icon sx={{ rotate: "180deg" }}>
                    <ExitToAppIcon />
                  </Icon>
                </IconButton>
                <Typography variant="caption" color="yellow" component="div" >
                  Happy? Tip me!
                </Typography>

                <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />

                <Typography variant="body2" color="inherit" component="div" sx={{ maxWidth: "25rem" }}>
                  {issueName}
                </Typography>


              </Toolbar>
            </AppBar>

          </Stack>
        </Box>
      </>
    )
  }

  const PageSlider = () => {
    return (
      <>


        {working ?
          <div className={"working_indicator"}>
            <Box sx={{ display: 'flex' }}>
              <CircularProgress disableShrink size='1rem' />
            </Box>
          </div>
          :
          <>
            {numPages > 0 &&

              <Box sx={{
                width: "90%"
              }}
                alignItems="center"
                spacing={2}
              >

                {!isNaN(currentPage) &&
                  <>
                    <Tooltip title="Jump to page" arrow followCursor enterDelay={500} enterNextDelay={2200}>
                      <CustSlider
                        onChangeCommitted={handleSliderChange}
                        aria-label="Page"
                        defaultValue={isNaN(currentPage) ? 0 : currentPage}
                        marks
                        valueLabelDisplay="on"
                        disabled={working}
                        step={1}
                        min={1}
                        max={numPages}

                      />
                    </Tooltip>

                    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }} >



                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom

                        alignItems="center"
                        sx={{
                          left: 0,
                          bottom: ".2rem",
                          opacity: "90%"
                        }}
                      >Page {isNaN(currentPage) ? 0 : currentPage} of {numPages} ({Math.floor((currentPage / numPages) * 100) + "%"})</Typography>

                    </Box>

                  </>
                }
              </Box>
            }
          </>
        }

      </>
    )
  }

  /*

 NAVIGATION

 */

  function useLatestCallback(callback) {
    const callbackRef = useRef(callback);

    // Update the callback ref on every render
    useEffect(() => {
      callbackRef.current = callback;
    });

    // Return a function that calls the latest callback
    return (...args) => callbackRef.current(...args);
  }



  function settingsClick() {
    setSettingsMenuOpenStore(true)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const zoomClick = useCallback((value) => {
    setZoomedStore(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);// eslint-disable-next-line react-hooks/exhaustive-deps


  const goFullScreen = () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }

  }

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
      document.msExitFullscreen();
    }

  }


  const goNextPage = useLatestCallback(() => {
    if (working || animating) { return }
    // console.log("currentPages[1] ", currentPages[1] )
    // console.log("numPages ", numPages)
    // console.log("currentPage ", currentPage)
    if ((portrait ? false : currentPages[1] >= numPages) || currentPage + 1 > numPages) {
      //reached end
      setEndStore(true)
      return
    }
    setWorkingStore(true)
    setCurrentActionStore(["goNextPage", null])
  });

  const goPrevPage = useLatestCallback(() => {
    if (working || animating) { return }
    if (currentPages[0] < 1) { return }
    if (currentPage - 1 < 1) { return }
    setWorkingStore(true)
    setCurrentActionStore(["goPrevPage", null])
  });

  const goNextPanel = useLatestCallback(() => {
    if (working || animating) { return }
    setCurrentActionStore(["goNextPanel", null])
  });

  const goPrevPanel = useLatestCallback(() => {
    if (working || animating) { return }
    setCurrentActionStore(["goPrevPanel", null])
  });

  const handleAlignment = (event, newAlignment) => {
    //event.preventDefault()
    setModeStore(newAlignment)
  }

  const handleBuildBounding = (event, newBuildBondings) => {
    //event.preventDefault()
    setBuildBoundingStore(newBuildBondings)
  }

  const handleGeneratePanelForPage = () => {
    setBuildGenerateStore(!buildGenerate)
  }


  const SettingsBTN = () => {
    return (
      <>
        <Stack spacing={2} alignItems="right">
          <Tooltip title="Settings" arrow>
            <span>
              <IconButton
                aria-label="settings"
                onClick={settingsClick}
                disabled={working}
              >
                <SettingsIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </>
    )
  }

  const FullscreenBTN = () => {
    return (
      <>
        {
          !isMobile() &&
          <Stack spacing={2} alignItems="right">
            {!fullscreen ?
              <Tooltip title="Fullscreen" arrow>
                <span>
                  <IconButton
                    aria-label="fullscreen"
                    onClick={goFullScreen}
                    disabled={working}
                  >
                    <FullscreenIcon />
                  </IconButton>
                </span>
              </Tooltip>
              :
              <Tooltip title="Exit fullscreen" arrow>
                <span>
                  <IconButton
                    aria-label="exit fullscreen"
                    onClick={exitFullScreen}
                    disabled={working}
                  >
                    <FullscreenExitIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }
          </Stack>
        }
      </>
    )
  }





  const ZoomBTN = () => {
    return (
      <>
        {
          mode === 'classic' &&


          <Stack spacing={2} alignItems="right">
            {!zoomed ?
              <Tooltip title="Zoom in" arrow>
                <span>
                  <IconButton
                    aria-label="back"
                    onClick={() => zoomClick(true)}
                    disabled={working}
                  >
                    <ZoomInIcon />
                  </IconButton>
                </span>
              </Tooltip>
              :
              <Tooltip title="Zoom out" arrow>
                <span>
                  <IconButton
                    aria-label="back"
                    onClick={() => zoomClick(false)}
                    disabled={working}
                  >
                    <ZoomOutIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }

          </Stack>
        }
      </>
    )
  }

  const BuildControls = () => {
    return (
      <>
        {
          mode === 'build' &&


          <Stack spacing={2} alignItems="center">
            <Toolbar>
              <ToggleButtonGroup
                color="primary"
                value={buildBounding}
                exclusive
                onChange={handleBuildBounding}
                aria-label="Build Controls"
                sx={{ m: 0.5 }}
                disabled={working}
              >

                <ToggleButton
                  value="boundingbox"
                  aria-label="bounding box"

                  disabled={working}
                >
                  <Tooltip title="Toggle Panel Add mode" arrow>
                    <CropIcon />
                  </Tooltip>
                </ToggleButton>

              </ToggleButtonGroup>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Tooltip title="Creates Panel Layer for current page" arrow>
                  <Button
                    onClick={handleGeneratePanelForPage}
                  >Generate</Button>
                </Tooltip>
              </ButtonGroup>

            </Toolbar>
          </Stack>

        }
      </>
    )
  }



  return (
    <>



      <div className="excel_menu_top">

        <div ref={topLeftAnchor} className="excel_menu_top"></div>


        {topLeftAnchor.current &&
          <>
            <ClickAwayListener onClickAway={(e) => forceCloseMenu(e)}>

              <Box
                className="excel_menu_top"
                sx={{
                  position: 'absolute',
                  display: 'block',
                  top: 0,
                  left: 0

                }}

              >
                {(!goOpenMenu && !showMenuAtFirst && !settingsMenuOpen) &&
                  !fabMenuSwitchValue && !isMobile() ?
                  <FabMenuButton
                    style={{ boxShadow: "0 0 8px 0px rgba(25, 118, 210, .5)", }}
                    className={fabHide ? "excel_fade_out" : "excel_fade_in"}
                    aria-label="menu"
                    sx={{ margin: 1 }}
                    onClick={openMenu}

                  >
                    <MenuIcon />
                  </FabMenuButton>
                  :
                  <>
                    <FabMenuButtonSmall
                      className={fabHide ? "excel_fade_out" : "excel_fade_in"}
                      aria-label="menu"
                      sx={{ margin: 1 }}
                      onClick={openMenu}
                    >
                      <MenuIcon />
                    </FabMenuButtonSmall>
                  </>
                }
                <Menu
                  position="static"
                  id="excel_menu"
                  onClose={mouseOffMe}
                  anchorEl={topLeftAnchor.current}
                  open={showMenuAtFirst || (goOpenMenu && !settingsMenuOpen)}
                  MenuListProps={{ onMouseLeave: mouseOffMe, onMouseOver: mouseOverMe }}

                  sx={{ width: "inherit" }}
                >
                  <BackToLibraryBar />




                  <Toolbar sx={{ justifyContent: "center" }}>

                    <Stack spacing={2} alignItems="left">
                      <Tooltip title={mode === "classic" ? "Previous page" : "Previous panel"} arrow>
                        <span>
                          <IconButton aria-label="back"
                            onClick={mode === 'classic' ? goPrevPage : goPrevPanel}
                            disabled={working}
                          >
                            <ArrowBackIosIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Stack>

                    <FullscreenBTN />

                    <Stack spacing={2} alignItems="center" marginLeft={isMobile() ? 0 : .25} marginRight={isMobile() ? 0 : .25} padding={isMobile() ? 0 : 1}>
                      <ToggleButtonGroup
                        color="primary"
                        value={mode}
                        exclusive
                        onChange={handleAlignment}
                        aria-label="Platform"
                        sx={{ m: 0.5 }}
                        disabled={working}
                      >

                        <ToggleButton value="classic">
                          <Tooltip title="Read it as the creators intended" arrow>
                            <span>Classic</span>
                          </Tooltip>
                        </ToggleButton>

                        <ToggleButton value="focus"
                          disabled={!issueObject || lockMode}
                          style={!issueObject ? { opacity: .5 } : { opacity: 1 }}
                        >
                          <Tooltip title="A cinematic experience" arrow>
                            <span>Cinema</span>
                          </Tooltip>
                        </ToggleButton>

                        {/* {admin &&
                <ToggleButton value="build"
                disabled={!issueObject}
                style={!issueObject?{opacity:.5}:{opacity:1}}
                >
                    <Tooltip title="Create Cinema Mode Object" arrow>
                        <span>Build</span>
                    </Tooltip>
                </ToggleButton>
                } */}


                      </ToggleButtonGroup>
                    </Stack>


                    <ZoomBTN />
                    <SettingsBTN />




                    <Stack spacing={2} alignItems="right">
                      <Tooltip title={mode === "classic" ? "Next page" : "Next panel"} arrow>
                        <span>
                          <IconButton aria-label="back"
                            onClick={mode === 'classic' ? goNextPage : goNextPanel}
                            disabled={working}
                          >
                            <ArrowForwardIosIcon />
                          </IconButton>
                        </span>
                      </Tooltip>

                    </Stack>

                  </Toolbar>
                  <BuildControls />
                  <br />

                  <Stack spacing={2} alignItems="center">
                    <PageSlider />

                  </Stack>

                </Menu>

              </Box>
            </ClickAwayListener>

          </>
        }

        <SettingsDrawer />


      </div>


    </>
  )


}
